import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  CircularProgress,
  Typography,
  makeStyles,
  useTheme,
  useMediaQuery,
} from "@material-ui/core";

import { i18n } from "../../translate/i18n";
import api from "../../services/api";
import toastError from "../../errors/toastError";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiDialog-paper": {
      width: "90%",
      maxWidth: "800px",
      maxHeight: "80vh",
    },
  },
  dialogContent: {
    padding: theme.spacing(2),
    minHeight: "auto",
  },
  loadingContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: theme.spacing(3),
  },
  noContactsContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: theme.spacing(3),
    color: theme.palette.text.secondary,
  },
}));

const ContactSourceContactsModal = ({ open, onClose, contactSource }) => {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  
  const [contacts, setContacts] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (open && contactSource) {
      fetchContacts();
    }
  }, [open, contactSource]);

  const fetchContacts = async () => {
    if (!contactSource) return;
    
    setLoading(true);
    try {
      const { data } = await api.get("/contacts", {
        params: { contactSourceId: contactSource.id }
      });
      
      const contactsList = data.contacts || data || [];
      setContacts(Array.isArray(contactsList) ? contactsList : []);
    } catch (err) {
      toastError(err);
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setContacts([]);
    onClose();
  };

  if (!contactSource) return null;

  return (
    <Dialog 
      open={open} 
      onClose={handleClose} 
      className={classes.root}
      fullScreen={isMobile}
    >
      <DialogTitle>
        {i18n.t("contactSources.contactsModal.title")}: <strong>{contactSource.name}</strong>
      </DialogTitle>
      <DialogContent className={classes.dialogContent}>
        {loading ? (
          <div className={classes.loadingContainer}>
            <CircularProgress />
          </div>
        ) : contacts.length === 0 ? (
          <div className={classes.noContactsContainer}>
            <Typography variant="body1">
              {i18n.t("contactSources.contactsModal.noContacts")}
            </Typography>
          </div>
        ) : (
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>{i18n.t("contactSources.contactsModal.table.name")}</TableCell>
                <TableCell>{i18n.t("contactSources.contactsModal.table.number")}</TableCell>
                <TableCell>{i18n.t("contactSources.contactsModal.table.email")}</TableCell>
                <TableCell>{i18n.t("contactSources.contactsModal.table.status")}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {contacts.map((contact) => (
                <TableRow key={contact.id}>
                  <TableCell>{contact.name}</TableCell>
                  <TableCell>{contact.number}</TableCell>
                  <TableCell>{contact.email || "-"}</TableCell>
                  <TableCell>
                    {contact.active ? "Ativo" : "Inativo"}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          {i18n.t("contactSources.contactsModal.close")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ContactSourceContactsModal; 